// Item labels for goods without a barcode (owner 2026-11-04, mockup item-label-v1 B): which GTIN the label carries and
// the GS1 element string — shared by the server that prints and the phone that shows what will be printed.
/** The GTIN an item label carries (owner 2026-11-04: "GTIN skall tas från artikeln"): the case level's code, else the
 *  article's only code; none → no label. */
export function labelGtinOf(gtins) {
    const ok = gtins.filter((g) => /^\d{14}$/.test(g.gtin));
    return (ok.find((g) => g.level === "case") ?? ok.find((g) => g.level === "pallet") ?? ok[0])?.gtin ?? null;
}
/** The GS1 element string of an item label, only what was filled in (owner 2026-11-04), fixed-length fields first and
 *  the batch last (GS1): (01) GTIN, (15) best before, the quantity, (10) batch. The quantity goes in the code only for a
 *  variable-measure GTIN (indicator 9): (30) a count, (311n) metres, (310n) kilograms; with a fixed GTIN GS1 allows no
 *  quantity beside (01), so it is printed as text only. Returns the string and the quantity's data title. */
export function itemLabelGs1(gtin, f) {
    let gs1 = `(01)${gtin}`;
    if (f.bestBefore)
        gs1 += `(15)${f.bestBefore.slice(2, 4)}${f.bestBefore.slice(5, 7)}${f.bestBefore.slice(8, 10)}`;
    let quantityTitle = null;
    let quantityInCode = false;
    const q = f.quantity != null && f.quantity !== "" ? Number(String(f.quantity).replace(",", ".")) : null;
    if (q !== null && Number.isFinite(q) && q > 0) {
        const variable = gtin.startsWith("9");
        const uom = (f.uom ?? "").toUpperCase();
        const measure = (ai) => {
            const decimals = Math.min(5, (String(q).split(".")[1] ?? "").length);
            const digits = String(Math.round(q * 10 ** decimals));
            return digits.length <= 6 ? `(${ai}${decimals})${digits.padStart(6, "0")}` : null;
        };
        if (variable && (uom === "MTR" || uom === "M")) {
            const m = measure("311");
            if (m) {
                gs1 += m;
                quantityInCode = true;
            }
            quantityTitle = "LENGTH (m)";
        }
        else if (variable && (uom === "KGM" || uom === "KG")) {
            const m = measure("310");
            if (m) {
                gs1 += m;
                quantityInCode = true;
            }
            quantityTitle = "NET WEIGHT (kg)";
        }
        else if (variable && Number.isInteger(q) && q <= 99_999_999) {
            gs1 += `(30)${q}`;
            quantityInCode = true;
            quantityTitle = "VAR. COUNT";
        }
        else
            quantityTitle = "QUANTITY";
    }
    if (f.lot)
        gs1 += `(10)${f.lot}`;
    return { gs1, quantityTitle, quantityInCode };
}
//# sourceMappingURL=item-label.js.map